<template>
   <div>

      <loading
         :active.sync="loading"
         :can-cancel="false"
         :is-full-page="true"
         :height="150"
         :width="150"
         :color="'#FFFF00'"
         :background-color="'#000000'"
         :opacity="0.5"
      ></loading>
      <v-container  fluid style="height: 100%; width:100%; float: left; padding-left: 0px">
   
         <div class="se-main-card">
         <v-row class="me-n5 mt-n4 mb-n8">
               <v-col
               cols="8"
               sm="8"
               class="ms-n2"
               >
                  <v-btn 
                     color="warning" 
                     style="width: 100px"
                     @click="backHandler" 
                     > 
                     {{$t('button.back')}}
                  </v-btn>
               </v-col>
   
               <v-col
               cols="4"
               sm="4"
               class="pe-0"
               >
               <v-autocomplete
                  outlined
                  :label="this.$t('reportstaffenquiry.hide_showcolumn')"
                  type="text"
                  v-model="hideColumn"
                  :items="hideList"
                  dense
                  clearable
                  multiple
               ></v-autocomplete>
               </v-col>
         </v-row>
   
         <v-row class="mt-2 mb-2">
         <v-expansion-panels>
            <v-expansion-panel>
               <v-expansion-panel-header>
               <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
               >{{$t('payrollenquiryreport.advancefilter')}}</v-subheader>
               </v-expansion-panel-header>
                     
                     <v-expansion-panel-content>
   
                        <div class="mt-8">
   
                           <v-row>
                              <v-col
                                 cols="3"
                                 sm="3"
                                 class="pb-4 mt-n8"
                              >
                              <v-autocomplete
                                 outlined
                                 :label="this.$t('reportsparam.parameters')"
                                 type="text"
                                 v-model="columnName"
                                 :items="columnList"
                                 dense
                                 clearable
                              ></v-autocomplete>
                              </v-col>
   
                              <v-col
                                 cols="2"
                                 sm="2"
                                 class="pb-4 mt-n8"
                              >
                              <v-autocomplete
                                 outlined
                                :label="this.$t('reportstaffenquiry.operation')"
                                 type="text"
                                 v-model="operationValue"
                                 :items="operationList"
                                 dense
                                 clearable
                              ></v-autocomplete>
                              </v-col>
   
                              <v-col
                                 cols="3"
                                 sm="3"
                                 class="pb-4 mt-n8"
                                 v-if="switchSearchType === 'A'"
                              >
                              <v-autocomplete
                                 outlined
                                 :label="this.$t('reportstaffenquiry.data')"
                                 type="text"
                                 v-model="searchValue"
                                 :items="searchList"
                                 dense
                                 clearable
                              ></v-autocomplete>
                              </v-col>
   
                              <v-col
                                 cols="3"
                                 sm="3"
                                 class="pb-4 mt-n8"
                                 v-else-if="switchSearchType === 'B'"
                              >
                              <v-text-field
                                 :label="this.$t('reportstaffenquiry.search')"
                                 v-model="userSearch"
                                 style="width: 250px"
                                 hide-details
                              ></v-text-field>
                              </v-col>
   
                              <v-col
                                 cols="3"
                                 sm="3"
                                 class="pb-4 mt-n8"
                                 v-else-if="switchSearchType === 'C'"
                              >
                              <v-text-field
                                 outlined
                                 :label="this.$t('setupwizardsetup.number')"
                                 type="number"
                                 v-model="numberValue"
                                 dense
                              ></v-text-field>
                              </v-col>
   
                              <v-col
                                 cols="3"
                                 sm="3"
                                 class="pb-4 mt-n8"
                                 v-else-if="switchSearchType === 'D'"
                              >
                              <v-text-field
                                 outlined
                                 :label="this.$t('columns.date')"
                                 type="date"
                                 v-model="dateValue"
                                 dense
                              ></v-text-field>
                              </v-col>
   
                              <v-tooltip bottom color="warning" v-if="refresh === false">
                              <template v-slot:activator="{ on, attrs }">
                                    <v-avatar class="mx-3 mt-n2" size="23" tile>
                                       <img
                                       :src="`${publicPath}images/reload.png`"
                                       @click="refreshTable"
                                       v-bind="attrs"
                                       v-on="on"
                                       />
                                    </v-avatar>
                              </template>
                              <span>{{$t('reportstaffenquiry.loaddata')}}</span>
                              </v-tooltip>
   
                              <v-tooltip bottom color="warning" v-if="refresh === false">
                              <template v-slot:activator="{ on, attrs }">
                                    <v-avatar class="mx-3 mt-n2" size="23" tile>
                                       <img
                                          :src="`${publicPath}images/and_orange.png`"
                                          @click="addSearchFilter"
                                          v-bind="attrs"
                                          v-on="on"
                                       />
                                    </v-avatar>
                              </template>
                              <span>{{$t('reportstaffenquiry.and')}}</span>
                              </v-tooltip>
   
                              <v-tooltip bottom color="warning" v-if="refresh === false">
                              <template v-slot:activator="{ on, attrs }">
                                    <v-avatar class="mx-3 mt-n2" size="23" tile>
                                       <img
                                          :src="`${publicPath}images/or.png`"
                                          @click="orFilter"
                                          v-bind="attrs"
                                          v-on="on"
                                       />
                                    </v-avatar>
                              </template>
                              <span>{{$t('reportstaffenquiry.or')}}</span>
                              </v-tooltip>
   
                              <v-tooltip bottom color="warning">
                              <template v-slot:activator="{ on, attrs }">
                                    <v-avatar class="mx-3 mt-n2" size="23" tile>
                                       <img
                                          :src="`${publicPath}images/bin_orange.png`"
                                          @click="clearTable"
                                          v-bind="attrs"
                                          v-on="on"
                                       />
                                    </v-avatar>
                              </template>
                              <span>{{$t('reportstaffenquiry.clearallfilter')}}</span>
                              </v-tooltip>
   
                           </v-row>
   
                           <v-row class="mx-3 mt-n8">
                              <h4>{{userSql}}</h4>
                           </v-row>
   
                           <v-row v-if="refresh === false">
                              <ul v-for="(content, index) in userArr" :key="index">
                                 <v-tooltip bottom color="error">
                                 <template v-slot:activator="{ on, attrs }">
                                    <li @click="removeFilter(content)"
                                    v-bind="attrs"
                                    v-on="on" 
                                    >{{content}}</li> 
                                 </template>
                                 <span>{{$t('reportstaffenquiry.remove')}}</span>
                                 </v-tooltip>
                              </ul>
                           </v-row>
   
                        </div>  
   
                     </v-expansion-panel-content>
   
            </v-expansion-panel>
         </v-expansion-panels>
         </v-row>
   
         <br>
   
         <v-row>
         <v-toolbar color="#ECEFF1">
   
            <h2 class="pt-3 pb-2" style="letter-spacing:normal;">
            {{ pageTitle }}
            </h2>
            <v-spacer></v-spacer>
             <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
               CSV
             </button>
             <button type="button" class="export-icon-btn export-icon-xls" @click="getXLSX" title="Export XLS">
               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="3" x2="9" y2="21"/></svg>
               XLS
             </button>
               
               <v-col
                  cols="3"
                  sm="3"
                  class="mt-6"
               >
               <v-autocomplete
                  outlined
                  :label="this.$t('reportstaffenquiry.grpby')"
                  type="text"
                  v-model="groupName"
                  :items="groupList"
                  background-color="white" 
                  dense
                  clearable
               ></v-autocomplete>
               </v-col>
   
               <v-tooltip bottom color="warning">
               <template v-slot:activator="{ on, attrs }">
                     <v-avatar class="mx-3" size="18" tile>
                        <img
                           :src="`${publicPath}images/reload.png`"
                           @click="addGroupBy"
                           v-bind="attrs"
                           v-on="on"
                        />
                     </v-avatar>
               </template>
               <span>{{$t('reportstaffenquiry.addgrp')}}</span>
               </v-tooltip>
   
               <v-tooltip bottom color="warning">
               <template v-slot:activator="{ on, attrs }">
                  <v-avatar class="mx-3" size="18" tile>
                     <img
                        :src="`${publicPath}images/bin_orange.png`"
                        @click="clearGroupBy"
                        v-bind="attrs"
                        v-on="on"
                     />
                  </v-avatar>
               </template>
               <span>{{$t('reportstaffenquiry.clearallgrp')}}</span>
               </v-tooltip>
   
         </v-toolbar>
         </v-row>
   
         <!-- --------------------------------- LIST SEARCH GROUP --------------------------------------- -->
         
         <v-row class="mt-4">
            <h4>{{$t('reportstaffenquiry.clearparameterused')}}</h4>
         </v-row>
   
         <v-row>
            <ul v-for="(content, index) in userGroup" :key="content">
               <v-tooltip bottom color="error">
               <template v-slot:activator="{ on, attrs }">
                  <li @click="deleteGroupBy(index)"
                  v-bind="attrs"
                  v-on="on" 
                  >{{content}}</li>
               </template>
               <span>{{$t('reportstaffenquiry.remove')}}</span>
               </v-tooltip>
            </ul>
         </v-row>
         
      <!-- --------------------------------- TABULATOR --------------------------------------- -->
         <v-row class="mt-4">
            <div ref="table"></div>
         </v-row>

         </div><!-- end se-main-card -->
   
      </v-container>
   </div>
</template>

<script>
import {TabulatorFull as Tabulator} from 'tabulator-tables';
import moment from 'moment';
import Loading from "vue-loading-overlay";

export default {

   components: {
        Loading
   },

   data() {
      return {

         // Image Path
         publicPath: process.env.BASE_URL,

         // Param
         pageTitle: this.$t('pmrewardenquiry.performancesalaryincrementenquiryfor') +  this.$route.params.rewardsimulationname,


         // Tabulator Function
         tabulator: null, //variable to hold your table
         tableData: [], //data for table to display

         

         // Default Setting
         column: [
            {title: this.$t('columns.staffcode'), field:"staffcode"},
            {title: this.$t('columns.name'), field:"psnname"}, 
            {title: this.$t('pmassementrecord.finalrank'), field:"finalrank"},
            {title: this.$t('columns.recorddate'), field:"recorddate"},
            {title: this.$t('claimlimitadjustmentrecord.adjustmentamount'), field:"adjustmentamount"},
            {title: this.$t('columns.currency'), field:"crcycode"},
            {title: this.$t('posted'), field:"posted"},
            {title: this.$t('pmrewardenquiry.dateposted'), field:"dateposted"},
            {title: this.$t('columns.company'), field:"compnyname"},
            {title: this.$t('columns.branch'), field:"brchname"},
            {title: this.$t('columns.department'), field:"deptname"},
            {title: this.$t('columns.section'), field:"sectioname"},
            {title: this.$t('columns.division'), field:"divnname"},
            {title: this.$t('columns.unit'), field:"unitname"},
            {title: this.$t('columns.grade'), field:"grdcode"},
            {title: this.$t('columns.employmenttype'), field:"emptype"},
         ],
         operationList: [
            {text:'=' , value:'='},
            {text:'<' , value:'<'},
            {text:'<=' , value:'<='},
            {text:'>' , value:'>'},
            {text:'>=' , value:'>='},
            {text:'!=' , value:'!='},
            {text:'Like' , value:'like'},
         ],
         switchSearchType: 'A',

         // V-model
         columnName: '',
         operationValue: '',
         userSearch: '',
         dateValue: '',
         searchValue: '',
         numberValue: '',

         //:List
         columnList: [],
         searchList: [],
         hideList: [],
         hideColumn: [],
         
         // Group By Function
         userGroup: [],
         group: [],
         groupList: [],
         groupName: '',

         // Test Data
         test: [undefined, undefined, undefined],
         sqlConstruct: [],
         userSeen: [],
         userArr: [],
         dummy: [],
         userSql: '',
         refresh: false,

         loading: false,
         errMsg: ''
      }
   },

   watch: {
      async columnName() {

         if(this.columnName === undefined) {
            this.searchList = [];
            this.searchValue = '';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'<' , value:'<'},
                  {text:'<=' , value:'<='},
                  {text:'>' , value:'>'},
                  {text:'>=' , value:'>='},
                  {text:'!=' , value:'!='},
                  {text:'Like' , value:'like'},
               ]
            if(this.operationValue === undefined || this.operationValue !== 'like') {
               this.switchSearchType = 'A';
               this.userSearch = '';
               this.numberValue = '';
               this.dateValue = '';
            } else if(this.operationValue === 'like') {
               this.switchSearchType = 'B'
               this.searchValue = '';
               this.numberValue = '';
               this.dateValue = '';
            }
         } else if(this.columnName === 'adjustmentamount' || this.columnName === 'finalrank') {
            this.switchSearchType = 'C';
            this.operationValue = undefined;
            this.operationList = [
               {text:'=' , value:'='},
               {text:'<' , value:'<'},
               {text:'<=' , value:'<='},
               {text:'>' , value:'>'},
               {text:'>=' , value:'>='},
            ]
            this.searchValue = '';
            this.userSearch = '';
            this.dateValue = '';
         } else if(this.columnName === 'recorddate' || this.columnName === 'dateposted') {
            this.searchValue = '';
            this.userSearch = '';
            this.numberValue = '';
            this.operationValue = undefined;
            this.switchSearchType = 'D';
            this.operationList = [
               {text:'=' , value:'='},
               {text:'<' , value:'<'},
               {text:'<=' , value:'<='},
               {text:'>' , value:'>'},
               {text:'>=' , value:'>='},
            ]
         } else {
            this.operationValue = undefined;
            const vm = this;

            vm.loading = true;
            vm.searchList = [];
            
            await this.$store.dispatch('get', {url: "/incrementenquiry/" + vm.rewardsimulationid})
               .then((res) => {
                  let item = res.data.rec;
      
                  let data = item.map(val => val[vm.columnName]); // .map is to take only "data" for that column : item.map(psnname);

                  for( let i = 0; i < data.length; i++){
                     vm.searchList.push(data[i]);
                  }

                  vm.loading = false;

               })
               .catch(function (err) {
                  vm.errMsg = err;
               });
            
            if(this.operationValue === undefined) {
               this.switchSearchType = 'A';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'!=' , value:'!='},
                  {text:'Like' , value:'like'},
               ]
               this.userSearch = '';
               this.numberValue = '';
               this.dateValue = '';
            } else if (this.operationValue === 'like') {
               this.switchSearchType = 'B';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'!=' , value:'!='},
                  {text:'Like' , value:'like'},
               ]
               this.searchValue = '';
               this.numberValue = '';
               this.dateValue = '';
            } else {
               this.switchSearchType = 'A';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'!=' , value:'!='},
                  {text:'Like' , value:'like'},
               ]
               this.userSearch = '';
               this.numberValue = '';
               this.dateValue = '';
            }
         }

         if(this.test[0] !== ''){
            this.test.splice(0, 1, this.columnName);
         } else {
            this.test.splice(0, 0, this.columnName);
         }
      },

      operationValue() {

         if(this.operationValue === undefined || this.operationValue !== 'like') {
            if(this.columnName === undefined) {
               this.switchSearchType = 'A';
               this.userSearch = '';
               this.numberValue = '';
               this.dateValue = '';
            } else if(this.columnName === 'adjustmentamount' || this.columnName === 'finalrank') {
               this.switchSearchType = 'C';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'<' , value:'<'},
                  {text:'<=' , value:'<='},
                  {text:'>' , value:'>'},
                  {text:'>=' , value:'>='},
               ]
               this.searchValue = '';
               this.userSearch = '';
               this.dateValue = '';
            } else if(this.columnName === 'recorddate' || this.columnName === 'dateposted') {
               this.switchSearchType = 'D';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'<' , value:'<'},
                  {text:'<=' , value:'<='},
                  {text:'>' , value:'>'},
                  {text:'>=' , value:'>='},
               ]
               this.searchValue = '';
               this.userSearch = '';
               this.numberValue = '';
            } else {
               this.switchSearchType = 'A';
               this.operationList = [
                  {text:'=' , value:'='},
                  {text:'!=' , value:'!='},
                  {text:'Like' , value:'like'},
               ]
               this.userSearch = '';
               this.numberValue = '';
               this.dateValue = '';
            }
         } else {
            this.switchSearchType = 'B';
            this.searchValue = '';
            this.numberValue = '';
            this.dateValue = '';
         }

         if(this.test[1] !== '') {
            this.test.splice(1, 1, this.operationValue);
         } else {
            this.test.splice(1, 0, this.operationValue);
         }
      },

      searchValue() {
         if(this.searchValue !== '') {
            if(this.test[2] !== '') {
               this.test.splice(2, 1, "'"+ this.searchValue + "'");
            } else {
               this.test.splice(2, 0, "'"+ this.searchValue + "'");
            }
         } else {
            this.test[2] = undefined;
         }

      },

      userSearch() {
         if(this.userSearch !== '') {
            if(this.test[2] !== '') {
               this.test.splice(2, 1, "'"+ "%" + this.userSearch + "%" + "'");
            } else {
               this.test.splice(2, 0, "'"+ "%" + this.userSearch + "%" + "'");
            }
         } else {
            this.test[2] = undefined;
         }

      },

      numberValue() {
         this.spliceFunction(this.numberValue, this.test);
      },

      dateValue() {

         if(this.dateValue !== '') {
            if(this.test[2] !== '') {
               this.test.splice(2, 1, "'"+ this.dateValue + "'");
            } else {
               this.test.splice(2, 0, "'"+ this.dateValue + "'");
            }
         } else {
            this.test[2] = undefined;
         }
      },

      hideColumn() {

         for(let i = 0; i < this.column.length; i++){
            let arr = this.column[i].field;
            if(this.hideColumn.includes(arr)) {
               this.tabulator.hideColumn(arr);
            } else {
               this.tabulator.showColumn(arr);
            }
         }

      },

      userSeen() {

         this.userArr = [];
         
         if(this.refresh === false){
            this.userSql = '';
         }

         for(let i = 0; i < this.userSeen.length; i++) {
            
            if(this.userSeen[i] == ' AND ' || this.userSeen[i] == ' OR ') {
               console.log(this.userSeen[i]);
            } else {
               this.userArr.push(this.userSeen[i]);
            }
            
            this.userSql += this.userSeen[i];
         }
         
      }, 

   },

   methods: {

      // Column Name
      getColumnBy() {
         return new Promise((resolve) => {
            for(let i = 0; i < this.column.length; i++) {
               this.columnContent(this.groupList, i);
               this.columnContent(this.columnList, i);
               this.columnContent(this.hideList, i);
            }
            this.loading = false;
            resolve();
         });
      },

      addGroupBy() {
         if(this.groupName !== '') {
            this.userGroup.push(this.sqlSeenColumn(this.groupName));
            this.group.push(this.groupName); 
            this.tabulator.setGroupBy(this.group);
            this.groupName = '';
         }
      },

      clearGroupBy() {
         this.group = [];
         this.userGroup = [];
         this.tabulator.setGroupBy(this.group);
      },

      deleteGroupBy(x) {
         this.userGroup.splice(x,1);
         this.group.splice(x,1); // Removing Method
         this.tabulator.setGroupBy(this.group);
      },

      addSearchFilter() {
         
         if(this.test[0] !== undefined && this.test[1] !== undefined && this.test[2] !== undefined) {
            let userSeen = this.sqlSeenColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
            this.userSeen.push(userSeen);
            this.userSeen.push(' AND ');
            if(this.test[0] == 'adjustmentamount' || this.test[0] == 'finalrank'){
               let filter = this.sqlDateDiff(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            } else {
                if (this.test[0] === 'posted') {
                    // Remove quotes if present
                    let val = this.test[2];
                    if (typeof val === 'string') {
                        val = val.replace(/'/g, '');
                    }
                    if (val === 'Y') {
                        this.test[2] = "'1'";
                    } else if (val === 'N') {
                        this.test[2] = "'0'";
                    }
                }
               let filter = this.sqlColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            }
            // this.sqlConstruct.push(filter);
            this.sqlConstruct.push(' AND ');
            this.resetValue();
         } else {
            alert(this.$t('reportstaffenquiry.fillinfilter'));
         }

      },

      orFilter() {
        
       if(this.test[0] !== undefined && this.test[1] !== undefined && this.test[2] !== undefined) {
            let userSeen = this.sqlSeenColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
            this.userSeen.push(userSeen);
            this.userSeen.push(' OR ');
            if(this.test[0] == 'adjustmentamount' || this.test[0] == 'finalrank'){
               let filter = this.sqlDateDiff(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            } else {
                if (this.test[0] === 'posted') {
                    // Remove quotes if present
                    let val = this.test[2];
                    if (typeof val === 'string') {
                        val = val.replace(/'/g, '');
                    }
                    if (val === 'Y') {
                        this.test[2] = "'1'";
                    } else if (val === 'N') {
                        this.test[2] = "'0'";
                    }
                }
               let filter = this.sqlColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            }
            // let filter = this.sqlColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
            // this.sqlConstruct.push(filter);
            this.sqlConstruct.push(' OR ');
            this.resetValue();
         } else {
            alert(this.$t('reportstaffenquiry.fillinfilter'));
         }

      },

      deleteFilter(y) {

         if( this.userSeen[y] == ' AND ' || this.userSeen[y] == ' OR ' ) {
            console.log('Cannot be deleted');
         } else {

            if(this.userSeen.length < 3) {
               this.userSeen.splice(y,1); // Removing Method
               this.sqlConstruct.splice(y,1);
               this.userSeen.splice(y,1); 
               this.sqlConstruct.splice(y,1);
            } else {
               if( y === 0) {
                  this.userSeen.splice(y,1); // Removing Method
                  this.sqlConstruct.splice(y,1);
                  this.userSeen.splice(y,1); 
                  this.sqlConstruct.splice(y,1);
               } else {
                  this.userSeen.splice(y-1,1); // Removing Method
                  this.sqlConstruct.splice(y-1,1);
                  this.userSeen.splice(y-1,1); 
                  this.sqlConstruct.splice(y-1,1);
               }
               
            }
         }

      },

      removeFilter(x) {
         if(this.userSeen.includes(x)) {
            let i = this.userSeen.indexOf(x);
            this.deleteFilter(i);
         }
      },

      refreshTable() {

         if((this.test[0] !== undefined && this.test[1] !== undefined && this.test[2] !== undefined)) {
            let userSeen = this.sqlSeenColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
            this.userSeen.push(userSeen);
            if(this.test[0] == 'adjustmentamount' || this.test[0] == 'finalrank'){
               let filter = this.sqlDateDiff(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            } else {
                if (this.test[0] === 'posted') {
                    // Remove quotes if present
                    let val = this.test[2];
                    if (typeof val === 'string') {
                        val = val.replace(/'/g, '');
                    }
                    if (val === 'Y') {
                        this.test[2] = "'1'";
                    } else if (val === 'N') {
                        this.test[2] = "'0'";
                    }
                }
               let filter = this.sqlColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
               this.sqlConstruct.push(filter);
            }
            // let filter = this.sqlColumn(this.test[0]) + ' ' + this.test[1] + ' ' + this.test[2];
            // this.sqlConstruct.push(filter);
            this.sqlQuery(this.sqlConstruct);
            this.resetValue();

            this.refresh = !this.refresh;
            
            const vm = this;

            vm.loading = true;
            
            this.$store.dispatch('post', {url: "/incrementenquirydata/" + vm.rewardsimulationid, payload: {dummy: vm.dummy}})
               .then((res) => {
                  let data = res.data.rec;

                  for (let i = 0; i < data.length; i++) {
                     if (data[i].recorddate) {
                           data[i].recorddate = moment(data[i].recorddate).format('DD-MM-YYYY');
                     }
                    if (data[i].dateposted) {
                        data[i].dateposted = moment(data[i].dateposted).format('DD-MM-YYYY');
                    }
                  }

                  vm.tabulator.setData(data);
                  vm.sqlConstruct = [];
                  vm.dummy = [];
                  vm.loading = false;

               })
               .catch(function (err) {
                  vm.errMsg = err;
               });

        } else if(this.sqlConstruct.length !== 0) {
            alert(this.$t('reportstaffenquiry.expectanotherfilter'));
        } else {
            alert(this.$t('reportstaffenquiry.fillinfilter'));
        }

      },

      clearTable() {
         this.userSeen = [];
         this.userArr = [];
         this.userSql = '';
         this.sqlConstruct = [];
         this.dummy = [];
         this.tabulator.setData(this.tableData);
         this.refresh = false;
      },

      // Repeated Code Function

      columnContent(x, y) {
         x.push(
               {text: this.column[y].title, value: this.column[y].field}
         );
      },

      spliceFunction(value, store) {
         if(value !== '') {
            if(store[2] !== '') {
               store.splice(2, 1, value);
            } else {
               store.splice(2, 0, value);
            }
         } else {
            store[2] = undefined;
         }

      },

      sqlColumn(x) {
        if ( x === 'compnyname' || x === 'branchname' || x === 'deptname' || x === 'sectioname' || x === 'divnname' || x === 'unitname' || x === 'grdcode' || x === 'emptype' || x === 'staffcode' ) {
        return x = 'vsm.' + x;
        } else if(x === 'crcycode') {
        return x = 'cry.' + x;
        } else if(x === 'psnname') {
        return x = 'vs.' + x;
        } else if(x === 'recorddate' || x === 'dateposted' || x ==='posted') {
        return x = 'vri.' + x;
        } else if(x === 'finalrank') {
        return x = 'ar.' + x;
        }
        else {
        return x;
        }
      },

      sqlDateDiff(x) { 
         console.log(x);
         return x = `rsd.finalincreamt `;
      },

      sqlSeenColumn(x) {

         for(let i = 0; i < this.column.length; i++) {
            let field =  this.column[i].field;
            let title = this.column[i].title;

            if( field === x ) {
               return x = title;
            }
         } 

      },

      sqlQuery(x) {

         for(let i = 0; i < x.length; i++) {
            this.dummy += x[i];
         }

      },

      resetValue() {
            this.columnName = undefined;
            this.operationValue = undefined;
            this.userSearch = undefined;
            this.dateValue = undefined;
            this.searchValue = undefined;
            this.numberValue = undefined;
      },

      // Axios Function

      async getIncrementEnquiry() {
         const vm = this;

         this.loading = true;

         try {
            const res = await this.$store.dispatch('get', {url: "/incrementenquiry/" + vm.rewardsimulationid})
            
               vm.tableData = res.data.rec;

               for (let i = 0; i < vm.tableData.length; i++) {
                    if (vm.tableData[i].recorddate) {
                        vm.tableData[i].recorddate = moment(vm.tableData[i].recorddate).format('DD-MM-YYYY');
                    }
                    if (vm.tableData[i].dateposted) {
                        vm.tableData[i].dateposted = moment(vm.tableData[i].dateposted).format('DD-MM-YYYY');
                    }
                    if (vm.tableData[i].adjustmentamount) {
                        vm.tableData[i].adjustmentamount = Number(vm.tableData[i].adjustmentamount).toFixed(2);
                    }
               }

               vm.tabulator = new Tabulator(vm.$refs.table, {
               
               reactiveData: true, // Reactive Data
               data: vm.tableData, // Table Data
               columns: vm.column, // Table columns      
               groupBy: vm.group, // Group By Function

               height:"350px",
               layout: "fitData",
               pagination: true,
               paginationSize: 10,
               paginationSizeSelector:[10, 25, 50, 100, true], 
               movableColumns: true,

               });

               // let language = require(`../../../locales/${this.$route.params.lang}.json`);
               // vm.tabulator.langs = language.tabulatorlang;
               // vm.tabulator.setLocale(this.$route.params.lang);

               // vm.loading = false;

               // console.log(vm.tabulator);

               await this.getColumnBy();
            }
            catch (err) {
               vm.errMsg = err;
            }

      },

      getCSV() {
         this.tabulator.download("csv", this.$t('pmrewardenquiry.incrementenquiry') + ".csv", {bom:true});
      },

      getXLSX() {
         this.tabulator.download("xlsx", this.$t('pmrewardenquiry.incrementenquiry') + ".xlsx", {});
      },

      backHandler(){
         this.$router.push({name: 'pmrewardincrementenquiry'});
      },
   },

   created() {
      const vm = this;
      vm.rewardsimulationid = this.$route.params.rewardsimulationid;
      
      const xlsx = document.createElement('script');  
      xlsx.setAttribute('src',"https://oss.sheetjs.com/sheetjs/xlsx.full.min.js");
      document.head.appendChild(xlsx);
   },

   async mounted() {
      await this.getIncrementEnquiry();
   },
}
</script>

<style scoped>
.se-main-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #E8EDF5;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 20px 28px 32px;
  margin-top: 8px;
}
@import  "./../../../../node_modules/tabulator-tables/dist/css/tabulator.min.css";
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s; margin-right: 4px;
}
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }
.export-icon-xls { background: #EFF6FF; color: #2563EB; border: 1px solid #BFDBFE; }
.export-icon-xls:hover { background: #2563EB; color: #fff; border-color: #2563EB; }

</style>